














































import { Component, Vue } from 'vue-property-decorator';
import carousel from '../components/carousel.vue';
import courseBookList from '../components/courseBookList.vue';
@Component({
  components: {
    carousel,
    courseBookList,
  },
})
export default class Home extends Vue {}
